import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";

export enum ACCESS_TYPE {
  MANAGED = "admin",
  REGISTERED = "registered",
  TEMPORARY = "temporary",
}

export const ACCESS_TYPE_ORDER = [
  ACCESS_TYPE.MANAGED,
  ACCESS_TYPE.REGISTERED,
  ACCESS_TYPE.TEMPORARY,
];

export const isAccessTypeVisible = (
  accountLevel: ProfileAccountInfo["accountLevel"],
  accessType: ACCESS_TYPE
) => {
  if (accessType === ACCESS_TYPE.TEMPORARY) {
    return accountLevel === LEVEL_TYPE.EU;
  }
  return true;
};

export const isAccessTypeDisabled = (
  account: ProfileAccountInfo,
  accessType: ACCESS_TYPE
): boolean => {
  if (accessType === ACCESS_TYPE.REGISTERED) {
    return account.userPermission.groupName?.toUpperCase() === "HIDDEN";
  }
  // if (
  //   account.isOnlyCustomUser ||
  //   account.isAdminGroup ||
  //   account.isTemporaryAccess === TEMPORARY_ACCESS_STATUS.ACC
  // ) {
  //   return accessType === ACCESS_TYPE.MANAGED;
  // }
  return false;
};
